import React from 'react';

import { Mui } from 'components';

import { buildMenuKey, isItemVisible } from './menuFavorites';
import NavItem from './NavItem';

function getSubmenuOpenState({ menuKey, submenuPrefs }) {
  if (menuKey in submenuPrefs) return submenuPrefs[menuKey];

  return true;
}

export function renderLeafItem({
  item,
  depth,
  index,
  menuKey,
  favoriteKeys,
  onFavoriteToggle,
  accentColor,
  railMode,
}) {
  const isFavorite = favoriteKeys.includes(menuKey);
  const canFavorite = item.favoriteable !== false;

  return (
    <NavItem
      depth={depth}
      href={item.href}
      target={item.target}
      icon={item.icon}
      disabled={item.disabled}
      key={[index, depth].join('-')}
      info={item.info}
      title={item.title}
      isNew={item.isNew}
      isStaff={item.isStaff}
      favoriteable={canFavorite}
      isFavorite={isFavorite}
      onFavoriteToggle={canFavorite ? () => onFavoriteToggle(menuKey) : undefined}
      accentColor={accentColor}
      railMode={railMode}
      badgeContent={item.badgeContent}
    />
  );
}

function reduceChildRoutes(props) {
  const {
    acc,
    pathname,
    index,
    isStaff,
    item,
    depth = 0,
    sectionKey,
    submenuPrefs,
    onSubmenuToggle,
    parentKey = '',
    favoriteKeys,
    onFavoriteToggle,
    accentColor,
    railMode,
  } = props;

  const key = [index, depth].join('-');
  const menuKey = buildMenuKey({ sectionKey, parentKey, title: item.title, id: item.menuKey });

  if (item.items) {
    const open = getSubmenuOpenState({ menuKey, submenuPrefs });

    acc.push(
      <NavItem
        isBranch
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={open}
        onToggle={() => onSubmenuToggle(menuKey, !open)}
        title={item.title}
        isNew={item.isNew}
        isStaff={item.isStaff}
        accentColor={accentColor}
        railMode={railMode}>
        {renderNavItems({
          depth: depth + 1,
          pathname,
          isStaff,
          items: item.items,
          sectionKey,
          submenuPrefs,
          onSubmenuToggle,
          parentKey: menuKey,
          favoriteKeys,
          onFavoriteToggle,
          accentColor,
          railMode,
        })}
      </NavItem>,
    );
  } else {
    acc.push(
      renderLeafItem({
        item,
        depth,
        index,
        menuKey,
        favoriteKeys,
        onFavoriteToggle,
        accentColor,
        railMode,
      }),
    );
  }

  return acc;
}

export function renderNavItems({ items, isStaff, ...rest }) {
  if (!Array.isArray(items)) {
    console.warn('renderNavItems: items is not an array', items);
    return null;
  }

  return (
    <Mui.List disablePadding>
      {items
        .filter(item => isItemVisible(item, isStaff))
        .reduce(
          (acc, item, index) => reduceChildRoutes({ acc, isStaff, item, index, ...rest }),
          [],
        )}
    </Mui.List>
  );
}
